{
  "id": "currencies",
  "name": "Currencies",
  "standard": "ISO 4217",
  "version": "List One 2026-01-01",
  "granularity": "Current currency codes, excluding funds, accounting and indexed units, precious metals, testing and no-currency entries",
  "license": "Publisher terms; freely available currency code list, no SPDX license asserted",
  "licenseUrl": "https://www.six-group.com/en/products-services/financial-information/market-reference-data/data-standards.html",
  "attribution": "SIX Financial Information AG, ISO 4217 Maintenance Agency. Deduplicated and filtered from Current Currency & Funds List One.",
  "sourceUrl": "https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list-one.xml",
  "sourceSha256": "838dfb991648cf36df939edd5fe3811737962b75a32252847d239cedd1e291c9",
  "retrievedAt": "2026-09-12",
  "options": [
    {
      "value": "AFN",
      "label": "Afghani (AFN)"
    },
    {
      "value": "DZD",
      "label": "Algerian Dinar (DZD)"
    },
    {
      "value": "ARS",
      "label": "Argentine Peso (ARS)"
    },
    {
      "value": "AMD",
      "label": "Armenian Dram (AMD)"
    },
    {
      "value": "AWG",
      "label": "Aruban Florin (AWG)"
    },
    {
      "value": "AUD",
      "label": "Australian Dollar (AUD)"
    },
    {
      "value": "AZN",
      "label": "Azerbaijan Manat (AZN)"
    },
    {
      "value": "BSD",
      "label": "Bahamian Dollar (BSD)"
    },
    {
      "value": "BHD",
      "label": "Bahraini Dinar (BHD)"
    },
    {
      "value": "THB",
      "label": "Baht (THB)"
    },
    {
      "value": "PAB",
      "label": "Balboa (PAB)"
    },
    {
      "value": "BBD",
      "label": "Barbados Dollar (BBD)"
    },
    {
      "value": "BYN",
      "label": "Belarusian Ruble (BYN)"
    },
    {
      "value": "BZD",
      "label": "Belize Dollar (BZD)"
    },
    {
      "value": "BMD",
      "label": "Bermudian Dollar (BMD)"
    },
    {
      "value": "BOB",
      "label": "Boliviano (BOB)"
    },
    {
      "value": "VED",
      "label": "Bolívar Soberano (VED)"
    },
    {
      "value": "VES",
      "label": "Bolívar Soberano (VES)"
    },
    {
      "value": "BRL",
      "label": "Brazilian Real (BRL)"
    },
    {
      "value": "BND",
      "label": "Brunei Dollar (BND)"
    },
    {
      "value": "BIF",
      "label": "Burundi Franc (BIF)"
    },
    {
      "value": "CVE",
      "label": "Cabo Verde Escudo (CVE)"
    },
    {
      "value": "CAD",
      "label": "Canadian Dollar (CAD)"
    },
    {
      "value": "XCG",
      "label": "Caribbean Guilder (XCG)"
    },
    {
      "value": "KYD",
      "label": "Cayman Islands Dollar (KYD)"
    },
    {
      "value": "XOF",
      "label": "CFA Franc BCEAO (XOF)"
    },
    {
      "value": "XAF",
      "label": "CFA Franc BEAC (XAF)"
    },
    {
      "value": "XPF",
      "label": "CFP Franc (XPF)"
    },
    {
      "value": "CLP",
      "label": "Chilean Peso (CLP)"
    },
    {
      "value": "COP",
      "label": "Colombian Peso (COP)"
    },
    {
      "value": "KMF",
      "label": "Comorian Franc (KMF)"
    },
    {
      "value": "CDF",
      "label": "Congolese Franc (CDF)"
    },
    {
      "value": "BAM",
      "label": "Convertible Mark (BAM)"
    },
    {
      "value": "NIO",
      "label": "Cordoba Oro (NIO)"
    },
    {
      "value": "CRC",
      "label": "Costa Rican Colon (CRC)"
    },
    {
      "value": "CUP",
      "label": "Cuban Peso (CUP)"
    },
    {
      "value": "CZK",
      "label": "Czech Koruna (CZK)"
    },
    {
      "value": "GMD",
      "label": "Dalasi (GMD)"
    },
    {
      "value": "DKK",
      "label": "Danish Krone (DKK)"
    },
    {
      "value": "MKD",
      "label": "Denar (MKD)"
    },
    {
      "value": "DJF",
      "label": "Djibouti Franc (DJF)"
    },
    {
      "value": "STN",
      "label": "Dobra (STN)"
    },
    {
      "value": "DOP",
      "label": "Dominican Peso (DOP)"
    },
    {
      "value": "VND",
      "label": "Dong (VND)"
    },
    {
      "value": "XCD",
      "label": "East Caribbean Dollar (XCD)"
    },
    {
      "value": "EGP",
      "label": "Egyptian Pound (EGP)"
    },
    {
      "value": "SVC",
      "label": "El Salvador Colon (SVC)"
    },
    {
      "value": "ETB",
      "label": "Ethiopian Birr (ETB)"
    },
    {
      "value": "EUR",
      "label": "Euro (EUR)"
    },
    {
      "value": "FKP",
      "label": "Falkland Islands Pound (FKP)"
    },
    {
      "value": "FJD",
      "label": "Fiji Dollar (FJD)"
    },
    {
      "value": "HUF",
      "label": "Forint (HUF)"
    },
    {
      "value": "GHS",
      "label": "Ghana Cedi (GHS)"
    },
    {
      "value": "GIP",
      "label": "Gibraltar Pound (GIP)"
    },
    {
      "value": "HTG",
      "label": "Gourde (HTG)"
    },
    {
      "value": "PYG",
      "label": "Guarani (PYG)"
    },
    {
      "value": "GNF",
      "label": "Guinean Franc (GNF)"
    },
    {
      "value": "GYD",
      "label": "Guyana Dollar (GYD)"
    },
    {
      "value": "HKD",
      "label": "Hong Kong Dollar (HKD)"
    },
    {
      "value": "UAH",
      "label": "Hryvnia (UAH)"
    },
    {
      "value": "ISK",
      "label": "Iceland Krona (ISK)"
    },
    {
      "value": "INR",
      "label": "Indian Rupee (INR)"
    },
    {
      "value": "IRR",
      "label": "Iranian Rial (IRR)"
    },
    {
      "value": "IQD",
      "label": "Iraqi Dinar (IQD)"
    },
    {
      "value": "JMD",
      "label": "Jamaican Dollar (JMD)"
    },
    {
      "value": "JOD",
      "label": "Jordanian Dinar (JOD)"
    },
    {
      "value": "KES",
      "label": "Kenyan Shilling (KES)"
    },
    {
      "value": "PGK",
      "label": "Kina (PGK)"
    },
    {
      "value": "KWD",
      "label": "Kuwaiti Dinar (KWD)"
    },
    {
      "value": "AOA",
      "label": "Kwanza (AOA)"
    },
    {
      "value": "MMK",
      "label": "Kyat (MMK)"
    },
    {
      "value": "LAK",
      "label": "Lao Kip (LAK)"
    },
    {
      "value": "GEL",
      "label": "Lari (GEL)"
    },
    {
      "value": "LBP",
      "label": "Lebanese Pound (LBP)"
    },
    {
      "value": "ALL",
      "label": "Lek (ALL)"
    },
    {
      "value": "HNL",
      "label": "Lempira (HNL)"
    },
    {
      "value": "SLE",
      "label": "Leone (SLE)"
    },
    {
      "value": "LRD",
      "label": "Liberian Dollar (LRD)"
    },
    {
      "value": "LYD",
      "label": "Libyan Dinar (LYD)"
    },
    {
      "value": "SZL",
      "label": "Lilangeni (SZL)"
    },
    {
      "value": "LSL",
      "label": "Loti (LSL)"
    },
    {
      "value": "MGA",
      "label": "Malagasy Ariary (MGA)"
    },
    {
      "value": "MWK",
      "label": "Malawi Kwacha (MWK)"
    },
    {
      "value": "MYR",
      "label": "Malaysian Ringgit (MYR)"
    },
    {
      "value": "MUR",
      "label": "Mauritius Rupee (MUR)"
    },
    {
      "value": "MXN",
      "label": "Mexican Peso (MXN)"
    },
    {
      "value": "MDL",
      "label": "Moldovan Leu (MDL)"
    },
    {
      "value": "MAD",
      "label": "Moroccan Dirham (MAD)"
    },
    {
      "value": "MZN",
      "label": "Mozambique Metical (MZN)"
    },
    {
      "value": "NGN",
      "label": "Naira (NGN)"
    },
    {
      "value": "ERN",
      "label": "Nakfa (ERN)"
    },
    {
      "value": "NAD",
      "label": "Namibia Dollar (NAD)"
    },
    {
      "value": "NPR",
      "label": "Nepalese Rupee (NPR)"
    },
    {
      "value": "ILS",
      "label": "New Israeli Sheqel (ILS)"
    },
    {
      "value": "TWD",
      "label": "New Taiwan Dollar (TWD)"
    },
    {
      "value": "NZD",
      "label": "New Zealand Dollar (NZD)"
    },
    {
      "value": "BTN",
      "label": "Ngultrum (BTN)"
    },
    {
      "value": "KPW",
      "label": "North Korean Won (KPW)"
    },
    {
      "value": "NOK",
      "label": "Norwegian Krone (NOK)"
    },
    {
      "value": "MRU",
      "label": "Ouguiya (MRU)"
    },
    {
      "value": "PKR",
      "label": "Pakistan Rupee (PKR)"
    },
    {
      "value": "MOP",
      "label": "Pataca (MOP)"
    },
    {
      "value": "TOP",
      "label": "Pa’anga (TOP)"
    },
    {
      "value": "UYU",
      "label": "Peso Uruguayo (UYU)"
    },
    {
      "value": "PHP",
      "label": "Philippine Peso (PHP)"
    },
    {
      "value": "GBP",
      "label": "Pound Sterling (GBP)"
    },
    {
      "value": "BWP",
      "label": "Pula (BWP)"
    },
    {
      "value": "QAR",
      "label": "Qatari Rial (QAR)"
    },
    {
      "value": "GTQ",
      "label": "Quetzal (GTQ)"
    },
    {
      "value": "ZAR",
      "label": "Rand (ZAR)"
    },
    {
      "value": "OMR",
      "label": "Rial Omani (OMR)"
    },
    {
      "value": "KHR",
      "label": "Riel (KHR)"
    },
    {
      "value": "RON",
      "label": "Romanian Leu (RON)"
    },
    {
      "value": "MVR",
      "label": "Rufiyaa (MVR)"
    },
    {
      "value": "IDR",
      "label": "Rupiah (IDR)"
    },
    {
      "value": "RUB",
      "label": "Russian Ruble (RUB)"
    },
    {
      "value": "RWF",
      "label": "Rwanda Franc (RWF)"
    },
    {
      "value": "SHP",
      "label": "Saint Helena Pound (SHP)"
    },
    {
      "value": "SAR",
      "label": "Saudi Riyal (SAR)"
    },
    {
      "value": "RSD",
      "label": "Serbian Dinar (RSD)"
    },
    {
      "value": "SCR",
      "label": "Seychelles Rupee (SCR)"
    },
    {
      "value": "SGD",
      "label": "Singapore Dollar (SGD)"
    },
    {
      "value": "PEN",
      "label": "Sol (PEN)"
    },
    {
      "value": "SBD",
      "label": "Solomon Islands Dollar (SBD)"
    },
    {
      "value": "KGS",
      "label": "Som (KGS)"
    },
    {
      "value": "SOS",
      "label": "Somali Shilling (SOS)"
    },
    {
      "value": "TJS",
      "label": "Somoni (TJS)"
    },
    {
      "value": "SSP",
      "label": "South Sudanese Pound (SSP)"
    },
    {
      "value": "LKR",
      "label": "Sri Lanka Rupee (LKR)"
    },
    {
      "value": "SDG",
      "label": "Sudanese Pound (SDG)"
    },
    {
      "value": "SRD",
      "label": "Surinam Dollar (SRD)"
    },
    {
      "value": "SEK",
      "label": "Swedish Krona (SEK)"
    },
    {
      "value": "CHF",
      "label": "Swiss Franc (CHF)"
    },
    {
      "value": "SYP",
      "label": "Syrian Pound (SYP)"
    },
    {
      "value": "BDT",
      "label": "Taka (BDT)"
    },
    {
      "value": "WST",
      "label": "Tala (WST)"
    },
    {
      "value": "TZS",
      "label": "Tanzanian Shilling (TZS)"
    },
    {
      "value": "KZT",
      "label": "Tenge (KZT)"
    },
    {
      "value": "TTD",
      "label": "Trinidad and Tobago Dollar (TTD)"
    },
    {
      "value": "MNT",
      "label": "Tugrik (MNT)"
    },
    {
      "value": "TND",
      "label": "Tunisian Dinar (TND)"
    },
    {
      "value": "TRY",
      "label": "Turkish Lira (TRY)"
    },
    {
      "value": "TMT",
      "label": "Turkmenistan New Manat (TMT)"
    },
    {
      "value": "AED",
      "label": "UAE Dirham (AED)"
    },
    {
      "value": "UGX",
      "label": "Uganda Shilling (UGX)"
    },
    {
      "value": "USD",
      "label": "US Dollar (USD)"
    },
    {
      "value": "UZS",
      "label": "Uzbekistan Sum (UZS)"
    },
    {
      "value": "VUV",
      "label": "Vatu (VUV)"
    },
    {
      "value": "KRW",
      "label": "Won (KRW)"
    },
    {
      "value": "YER",
      "label": "Yemeni Rial (YER)"
    },
    {
      "value": "JPY",
      "label": "Yen (JPY)"
    },
    {
      "value": "CNY",
      "label": "Yuan Renminbi (CNY)"
    },
    {
      "value": "ZMW",
      "label": "Zambian Kwacha (ZMW)"
    },
    {
      "value": "ZWG",
      "label": "Zimbabwe Gold (ZWG)"
    },
    {
      "value": "PLN",
      "label": "Zloty (PLN)"
    }
  ]
}
